import React from 'react'
import { css } from '@emotion/css'
import { FormattedMessage, FormattedDate } from 'react-intl'

const releaseDateSpacing = css`
  margin-top: 1.3px;
`

export interface LibraryReleaseDateProps {
  readonly releaseDate?: string
  readonly dateOnly?: boolean
  readonly showParenthesis?: boolean
}

export function LibraryReleaseDate({
  releaseDate,
  dateOnly,
  showParenthesis = true
}: LibraryReleaseDateProps) {
  return (
    <FormattedMessage id="title_libraries_versionTypeReleased">
      {() =>
        !!releaseDate ? (
          <FormattedDate
            value={releaseDate}
            {...{
              year: 'numeric',
              month: 'short',
              day: 'numeric'
            }}
          >
            {(formattedDate) => {
              return dateOnly ? (
                <span className={releaseDateSpacing}>{formattedDate}</span>
              ) : (
                <span className={releaseDateSpacing}>
                  {showParenthesis ? `(${formattedDate})` : formattedDate}
                </span>
              )
            }}
          </FormattedDate>
        ) : null
      }
    </FormattedMessage>
  )
}
